
import { Component, Input, isDevMode, OnInit } from '@angular/core';
import { HeaderFieldComponent, CellFieldComponent, AttachmentLookupComponent } from '../../common/index';
import { AdminService, MetadataService, AuthService, ApiService, SessionService, ModalService, ConditionService, CalendarService, TranslatorService, FieldService } from '../../../services';
import { ModalComponent } from '../../modal/modal.component';
import { Condition, User } from '../../../models';
import { UscStoreService } from '../../../services/usc-store/usc-store.service';
import { Subscription } from 'rxjs';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { UscTableViewComponent } from '../usc-table-view/usc-table-view.component';

@Component({
    selector: 'sn-usc-associate-scorecard',
    templateUrl: '../usc-table-view/usc-table-view.component.html',
    styleUrls: ['../usc-table-view/usc-table-view.component.css']
})    

export class UscAssociateScorecardComponent extends UscTableViewComponent {

    ngOnInit() {
        this.view = this.uscStoreService.view_p2w_associate_gross_adds_detail_results;
        this.isPreviousMonthEnabled = false;
        this.enabled_include_todays_sales = true;
        super.ngOnInit();
    }
    
    // filter(field, f) {
    //     field.current_filtered_value = (f.value == 'All' || f.value == '') ? null : f.value;
    //     this.curPage = 1;
    //     var current_user_scorecard = this.detail_items.find(i => i.CREATOR_ID == this.current_user.username);       // get associate info for filter initialization
    //     var cur_is_filtered_to_associate_store = this.is_filtered_to_associate_store;
    //     var store_filter = this.pageFilterFields.find(f => f.key == "store");
    //     this.is_filtered_to_associate_store = store_filter.current_filtered_value == current_user_scorecard.store;
    //     if (cur_is_filtered_to_associate_store != this.is_filtered_to_associate_store) {
    //         this.reloadItems(false);
    //     } else {
    //         this.updateDisplayDetailedItems();
    //     }
    // }
    // filter(field, f) {
    //     field.current_filtered_value = (f.value == 'All' || f.value == '') ? null : f.value;
    //     this.updateDisplayDetailedItems();
    // }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store-mobile/usc-associate-scorecard/usc-associate-scorecard.component.ts